import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    this.element['modalContent'] = this
  }

  submit(e) {
    e.preventDefault();

    fetch(e.target.action, {
      method: e.target.method,
      body: new FormData(e.target),
    }).then(response => {
      if (response.ok) {
        this.close();
      }
    })
  }

  cancel() {
    this.openBanner();
  }

  close(e = null) {
    if (this.element.modal) {
      this.element.modal.close(e);
    }
  }

  openBanner() {
    const cookieBanner = document.getElementById('cookieBanner');
    if (cookieBanner) {
      cookieBanner.style.display = 'block';
    }
  }
}
